import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '../_services/loading.service';
import { finalize } from 'rxjs';
import { environment } from '../../environments/environment';

export const SkipLoading = new HttpContextToken<boolean>(() => false);

const EXCLUDED_URL_PATTERNS = [
  environment.graphBaseUrl,
  environment.spoBaseUrl,
  environment.risBaseUrl,
];

function excludeUrlsFromLoading(url: string): boolean {
  return EXCLUDED_URL_PATTERNS.some((pattern) => url.includes(pattern));
}

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Check for a custom attribute to avoid showing loading spinner
  if (req.context.get(SkipLoading) || excludeUrlsFromLoading(req.url))
    return next(req); // Pass the request direct to the next handler

  loadingService.loadingOn();

  return next(req).pipe(
    finalize(() => {
      loadingService.loadingOff();
    }),
  );
};
